import { useCallback, useState } from 'react';

export const NAMED_FILTER_OPTIONS = [
  { name: 'Named Numbers', value: 'Named Numbers' },
  { name: 'All Numbers', value: 'All Numbers' },
];

export const All_NUMBERS_FILTER_OPTION = NAMED_FILTER_OPTIONS[1].value;
export const NAMED_FILTER_OPTION = NAMED_FILTER_OPTIONS[0].value;

export const DEFAULT_NAMED_FILTER_OPTION = All_NUMBERS_FILTER_OPTION;

export const useOutboundCallerIdFilters = () => {
  const [value, setValue] = useState<string | null>(null);
  const [areaCodes, setAreaCodes] = useState<string[]>([]);
  const [namedFilter, setNamedFilter] = useState<string>(
    DEFAULT_NAMED_FILTER_OPTION,
  );

  const onClear = useCallback(() => {
    setValue('');
    setAreaCodes([]);
    setNamedFilter(DEFAULT_NAMED_FILTER_OPTION);
  }, []);

  const hasFilters = useCallback(() => {
    return (
      !!value?.trim() ||
      areaCodes.length > 0 ||
      namedFilter !== DEFAULT_NAMED_FILTER_OPTION
    );
  }, [value, areaCodes, namedFilter]);

  return {
    value,
    onValueChange: setValue,
    areaCodes,
    onAreaCodesChange: setAreaCodes,
    namedFilter,
    onNamedFilterChange: setNamedFilter,
    hasFilters,
    onClear,
  };
};
